import React, { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { track } from '../../utils/analytics';

const READ_ONLY_AFTER_TRIAL = ['/planos', '/meus-laudos'];

const ProtectedRoute = ({ children }) => {
  const { user, billingState, loading, isAdmin } = useAuth();
  const location = useLocation();
  const lastPaywallRef = useRef(null);

  const hasActiveAccess = isAdmin || billingState?.active === true;
  const isReadOnlyRoute = READ_ONLY_AFTER_TRIAL.includes(location.pathname) || location.pathname.startsWith('/assinatura/');
  const shouldShowPaywall = !loading && Boolean(user) && !hasActiveAccess && !isReadOnlyRoute;

  useEffect(() => {
    if (!shouldShowPaywall) return;
    const key = `${user?.id || 'unknown'}:${location.pathname}`;
    if (lastPaywallRef.current === key) return;
    lastPaywallRef.current = key;
    track('paywall_viewed', {
      paywall_id: 'trial_expired',
      variant: 'hard_paywall_v1',
      trigger: 'trial_expired',
      blocked_route: location.pathname,
    });
  }, [shouldShowPaywall, user?.id, location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-paper-alt">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-navy mb-4"></div>
        <p className="text-muted font-medium">Carregando sua sessão...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (shouldShowPaywall) {
    return <Navigate to="/planos?trial=encerrado" replace />;
  }

  return children;
};

export default ProtectedRoute;
